<template>
  <div class="mobile-nav">
    <div class="mobile-bar">
      <router-link to="/" class="brand">
        <img class="logo" src="../assets/logo/firex-logo.jpeg" alt="FireX Logo" />
        <div class="brand-name">Fire<span>X</span></div>
      </router-link>

      <button class="hamburger" :class="{ open: isOpen }" @click="isOpen = !isOpen" aria-label="Menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <transition name="slide">
      <div class="mobile-menu" v-if="isOpen">
        <router-link to="/" class="mobile-link" @click.native="isOpen = false">Home</router-link>
        <router-link to="/Services" class="mobile-link" @click.native="isOpen = false">Services</router-link>
        <router-link to="/about-us" class="mobile-link" @click.native="isOpen = false">About</router-link>
        <router-link :to="{ path: '/', hash: '#contact' }" class="mobile-link" @click.native="isOpen = false">Contact</router-link>
        <a href="tel:7605673777" class="mobile-phone">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          760-567-3777
        </a>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    open() {
      this.isOpen = false;
      this.$emit("showQuote", true);
    }
  }
};
</script>

<style scoped>
.mobile-nav {
  display: none;
}

@media screen and (max-width: 900px) {
  .mobile-nav {
    display: block;
  }
}

.mobile-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 1.25rem;
  background: rgba(10, 10, 10, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--color-border);
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
}

.logo {
  height: 36px;
  border-radius: 6px;
}

.brand-name {
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-text);
}

.brand-name span {
  color: var(--color-fire);
}

.hamburger {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}

.hamburger span {
  display: block;
  width: 24px;
  height: 2px;
  background: var(--color-text);
  transition: all 0.3s;
  border-radius: 2px;
}

.hamburger.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.hamburger.open span:nth-child(2) {
  opacity: 0;
}

.hamburger.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.mobile-menu {
  display: flex;
  flex-direction: column;
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-border);
  padding: 1rem 0;
}

.mobile-link {
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  color: var(--color-text-muted);
  text-decoration: none;
  transition: color 0.2s, background 0.2s;
}

.mobile-link:hover {
  color: var(--color-text);
  background: var(--color-surface-raised);
}

.mobile-phone {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 1.5rem;
  padding: 0.75rem 1.25rem;
  background: var(--color-fire);
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
  border-radius: 4px;
  text-decoration: none;
  justify-content: center;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
